import React from 'react';

import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarClearance,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';
import { MobileFilterWrapper } from '@/modules/CarsStock/components/common.styles';
import StockFilterRange from '@/components/StockFilterRange';

function ClearanceFilter() {
  const dispatch = useTypedDispatch();
  const selectedClearance =
    useTypedSelector(getSelectedFilters).selectedParams.selectedClearance;

  const handleBlurClearance = (clearance: RangeType) => {
    dispatch(setCarClearance(clearance));
    dispatch(setPage(1));
  };

  return (
    <MobileFilterWrapper>
      <StockFilterRange
        label="Клиренс, мм"
        values={selectedClearance}
        onBlur={handleBlurClearance}
      />
    </MobileFilterWrapper>
  );
}

export default ClearanceFilter;
